var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1685_2106)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 35.5,
    width: 11,
    height: 11,
    rx: 5.5,
    stroke: "#008CB7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 72.5V69.5M25.5 72.5V57C25.5 53.4101 28.4101 50.5 32 50.5V50.5C35.5899 50.5 38.5 53.4101 38.5 57V58L46.3178 54.0911C48.0387 53.2306 50.1284 54.0081 50.8684 55.7841V55.7841C51.5143 57.3342 50.9013 59.1226 49.4402 59.9506L41.2803 64.5745C38.9052 65.9204 35.8897 65.1125 34.5056 62.7595L32 58.5M51 55L59.5 41M42.5 41.5H52.5M42.5 34.5H62.5M34.5 31.5V29.5C34.5 27.2909 36.2909 25.5 38.5 25.5H66C68.2091 25.5 70 27.2909 70 29.5V43.5C70 45.7091 68.2091 47.5 66 47.5H63",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1685_2106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsg7);
export default __webpack_public_path__ + "static/media/esg7.682bee992a850f8901c101eb4a273160.svg";
export { ForwardRef as ReactComponent };